import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { includes } from 'lodash';
import { Type } from '@lendi/lala-react';
import { Button, IconButton } from '@lendi-ui/button';
import { Checkbox } from '@lendi-ui/checkbox';
import getColour from '@lendi-ui/commons/colours';
import Close from '@lendi-ui/icon/Close';
import { Radio } from '@lendi-ui/radio';

import { Body } from '@funnels/ui-components';
import { AUSSIE_CUSTOMER_BASE_URL, authUtil, LENDI_CUSTOMER_BASE_URL } from '@funnels/utils';

import {
  CheckBoxWrapper,
  Container,
  MockDataWrapper,
  ToolContainer,
  ToolSticker,
  ToolWrapper,
  Warning,
} from './index.style';
import Urls from './Urls';

function ToolBar(props: any) {
  const { pathname } = useLocation();
  const [showConfig, setConfig] = useState(false);
  const [showMockData, setEditMode] = useState(false);
  const [showInviteConfig, setInviteConfig] = useState(false);
  const [showUrls, setShowUrls] = useState(false);
  const vendor = localStorage.getItem('vendor');
  const view = localStorage.getItem('_lendi_funnels_debug_view');
  const token = authUtil.getToken();
  const tokenTemp = localStorage.getItem('_lendi_funnels_debug_token_temporary_storage');
  const isShowingConfigBar = localStorage.getItem('_lendi_funnels_debug_config_bar') === 'show';
  const hasToken = !!token || !!tokenTemp;
  const mockDataType = localStorage.getItem('_lendi_funnels_debug_mock_data');
  const useMockAPI = localStorage.getItem('_lendi_funnels_debug_use_mock_api');
  const bypass = !!localStorage.getItem('_lendi_funnels_debug_bypass_auth');
  const initialInvite = localStorage.getItem('_lendi_funnels_debug_initial_invite');
  useEffect(() => {
    const isEditMode = includes(pathname, '/edit');
    const showInvite = includes(pathname, '/invite') || /(?=.*team-view)(?=.*applicants)/.test(window.location.href);

    setConfig(isShowingConfigBar);
    setEditMode(isEditMode);
    setInviteConfig(showInvite);
    // eslint-disable-next-line
  }, [pathname]);

  function toggleAussieVendor(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      localStorage.setItem('vendor', 'Aussie');
      window.location.replace(window.location.pathname.replace(LENDI_CUSTOMER_BASE_URL, AUSSIE_CUSTOMER_BASE_URL));
    } else {
      localStorage.removeItem('vendor');
      window.location.replace(window.location.pathname.replace(AUSSIE_CUSTOMER_BASE_URL, LENDI_CUSTOMER_BASE_URL));
    }
  }

  function toggleView(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      localStorage.setItem('_lendi_funnels_debug_view', Type.Team);
    } else {
      localStorage.removeItem('_lendi_funnels_debug_view');
    }
    window.location.reload();
  }

  function toggleToken(e: React.ChangeEvent<HTMLInputElement>) {
    const t = token || tokenTemp || '';
    if (e.target.checked) {
      localStorage.setItem('token', t);
      localStorage.removeItem('_lendi_funnels_debug_token_temporary_storage');
    } else {
      localStorage.setItem('token', '');
      localStorage.setItem('_lendi_funnels_debug_token_temporary_storage', t);
    }
    window.location.reload();
  }

  function toggleNewAPI(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      localStorage.setItem('_lendi_funnels_debug_use_mock_api', 'true');
    } else {
      localStorage.removeItem('_lendi_funnels_debug_use_mock_api');
    }
    window.location.reload();
  }

  function toggleMockData(e: React.ChangeEvent<HTMLInputElement>) {
    localStorage.setItem('_lendi_funnels_debug_mock_data', e.target.value);
    window.location.reload();
  }

  function toggleConfigBar() {
    const toggleConfigBar = isShowingConfigBar ? 'hide' : 'show';
    localStorage.setItem('_lendi_funnels_debug_config_bar', toggleConfigBar);
    setConfig(!isShowingConfigBar);
  }

  function toggleBypass(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      localStorage.setItem('_lendi_funnels_debug_bypass_auth', 'true');
    } else {
      localStorage.removeItem('_lendi_funnels_debug_bypass_auth');
    }
    window.location.reload();
  }
  function toggleInitialInvite(e: React.ChangeEvent<HTMLInputElement>) {
    localStorage.setItem('_lendi_funnels_debug_initial_invite', e.target.value);
    window.location.reload();
  }

  return (
    <>
      <Container isVisible={showConfig}>
        <ToolContainer>
          <ToolWrapper>
            <CheckBoxWrapper>
              <Checkbox label="Aussie" isChecked={vendor === 'Aussie'} onChange={toggleAussieVendor} />
              <Checkbox label="Team View" isChecked={view === 'team'} onChange={toggleView} />
              <Checkbox label="Bypass auth" isChecked={bypass} onChange={toggleBypass} />
              <Checkbox
                label={hasToken ? 'Auth' : 'Auth (please login first)'}
                isChecked={!!token}
                isDisabled={!hasToken}
                onChange={toggleToken}
              />
              <Checkbox label={'Use Mock API'} isChecked={useMockAPI === 'true'} onChange={toggleNewAPI} />
            </CheckBoxWrapper>
            <Warning>Page will reload whenever you click the checkboxs</Warning>
          </ToolWrapper>
          <Button size="xs" variant="primary" onClick={() => setShowUrls(true)}>
            Show Urls
          </Button>
          <IconButton aria-label="Close" onClick={toggleConfigBar} size="xs" icon={Close} />
        </ToolContainer>
        {showInviteConfig && (
          <MockDataWrapper>
            <Body size="lg" color={getColour('interaction', 'main')} mt="xs">
              Customer Invite
            </Body>
            <CheckBoxWrapper>
              <Radio
                label="No invites"
                value="true"
                isChecked={initialInvite === 'true'}
                onChange={toggleInitialInvite}
              />
              <Radio
                label="Invites exist"
                value="false"
                isChecked={initialInvite === 'false'}
                onChange={toggleInitialInvite}
              />
            </CheckBoxWrapper>
          </MockDataWrapper>
        )}
        {showMockData && (
          <MockDataWrapper>
            <Body size="lg" color={getColour('interaction', 'main')} mt="xs">
              Refinance
            </Body>
            <CheckBoxWrapper>
              <Radio
                label="Decrease repayment"
                value="REFINANCE_DECREASE"
                isChecked={mockDataType === 'REFINANCE_DECREASE'}
                onChange={toggleMockData}
              />
              <Radio
                label="Consolidate / Cash out"
                value="REFINANCE_CONSOLIDATE_CASHOUT"
                isChecked={mockDataType === 'REFINANCE_CONSOLIDATE_CASHOUT'}
                onChange={toggleMockData}
              />
              <Radio
                label="Knockdown rebuild"
                value="REFINANCE_REBUILD"
                isChecked={mockDataType === 'REFINANCE_REBUILD'}
                onChange={toggleMockData}
              />
            </CheckBoxWrapper>
            <Body size="lg" color={getColour('interaction', 'main')} mt="xs">
              New Purchase
            </Body>
            <CheckBoxWrapper>
              <Radio
                label="Offer made"
                value="NEW_PURCHASE_OFFER_MADE"
                isChecked={mockDataType === 'NEW_PURCHASE_OFFER_MADE'}
                onChange={toggleMockData}
              />
              <Radio
                label="Buying soon - New Building"
                value="NEW_PURCHASE_BUYING_SOON_NEW_BUILDING"
                isChecked={mockDataType === 'NEW_PURCHASE_BUYING_SOON_NEW_BUILDING'}
                onChange={toggleMockData}
              />
              <Radio
                label="Buying soon - Vacant land"
                value="NEW_PURCHASE_BUYING_SOON_VACANT_LAND"
                isChecked={mockDataType === 'NEW_PURCHASE_BUYING_SOON_VACANT_LAND'}
                onChange={toggleMockData}
              />
            </CheckBoxWrapper>
            <Body size="lg" color={getColour('interaction', 'main')} mt="xs">
              Borrowing Power
            </Body>
            <CheckBoxWrapper>
              <Radio
                label="Offer made"
                value="BORROWING_POWER_OFFER_MADE"
                isChecked={mockDataType === 'BORROWING_POWER_OFFER_MADE'}
                onChange={toggleMockData}
              />
              <Radio
                label="Buying soon - Vacant land"
                value="BORROWING_POWER_BUYING_SOON_VACANT_LAND"
                isChecked={mockDataType === 'BORROWING_POWER_BUYING_SOON_VACANT_LAND'}
                onChange={toggleMockData}
              />
            </CheckBoxWrapper>
            <Body size="lg" color={getColour('interaction', 'main')} mt="xs">
              Funnel one Data
            </Body>
            <CheckBoxWrapper>
              <Radio
                label="Funnel one"
                value="FUNNEL_ONE"
                isChecked={mockDataType === 'FUNNEL_ONE'}
                onChange={toggleMockData}
              />
            </CheckBoxWrapper>
          </MockDataWrapper>
        )}
      </Container>
      {!showConfig && <ToolSticker onClick={toggleConfigBar}>config</ToolSticker>}
      <Urls isVisible={showUrls} onHide={() => setShowUrls(false)} />
    </>
  );
}

export default ToolBar;
